<template>
  <div class="googlewrapper">
    <img width="100%" height="100%" :src="getImageURL()">
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'ImageWidget',

  computed: {
    ...mapGetters(['getLogoURL']),
  },

  props: {
    widgetData: Object
  },

  methods: {
    requestData() {},

    getImageURL() {
      let baseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:7000' : ''
      return baseURL + '/' + this.widgetData.image
    }

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.googlewrapper {
  background-color: white;
  color: black;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

</style>
